import { useScrollLock } from "~/contexts/ScrollLockProvider";

type PreventBodyScrollProps = {
  enabled?: boolean;
};

/**
 * Component form of `useScrollLock`, for locking body scroll from JSX.
 */
export function PreventBodyScroll({ enabled = false }: PreventBodyScrollProps) {
  useScrollLock(enabled);
  return null;
}
